var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6165 24 24 18.6165 24 12C24 5.3835 18.6165 0 12 0C5.3835 0 0 5.3835 0 12C0 18.6165 5.3835 24 12 24ZM12 23C9.147 23 6.544 21.9075 4.5875 20.1195L12.207 12.5H22.9875C22.725 18.334 17.898 23 12 23ZM22.9875 11.5H12.5V1.0125C18.1685 1.2675 22.7325 5.8315 22.9875 11.5ZM11.5 1.0125V11.793L3.8805 19.4125C2.0925 17.456 1 14.853 1 12C1 6.102 5.666 1.275 11.5 1.0125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsIcon);
export default __webpack_public_path__ + "static/media/ReportsIcon.cebce6063e01a2e70390e8cec05442ad.svg";
export { ForwardRef as ReactComponent };